import { render, staticRenderFns } from "./compreResult.vue?vue&type=template&id=11b30f2a&scoped=true"
import script from "./compreResult.vue?vue&type=script&lang=js"
export * from "./compreResult.vue?vue&type=script&lang=js"
import style0 from "./compreResult.vue?vue&type=style&index=0&id=11b30f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b30f2a",
  null
  
)

export default component.exports